/**
 * Parse UTC datetime strings into JavaScript Date objects
 *
 * Accepts:
 * - ISO 8601: "2020-04-01T12:16:54.000Z" or "2020-04-01T12:16:54Z"
 * - MySQL format: "2020-04-01 12:16:54" or "2020-04-01 12:16:54.5"
 *
 * Returns JavaScript Date object (automatically converted to browser's local timezone)
 *
 * Note: All modern browsers (Safari, Chrome, Firefox, Opera, Samsung Internet)
 * natively support ISO 8601 parsing via new Date() since IE9.
 */
const utcDateTimeToJsDate = (dateTime) => {
  if (typeof dateTime !== 'string') return new Date(dateTime);

  // If already in ISO format with 'Z' suffix, parse directly
  if (dateTime.endsWith('Z')) {
    return new Date(dateTime);
  }

  // MySQL format - convert "2020-04-01 12:16:54" to "2020-04-01T12:16:54Z"
  const isoString = dateTime.replace(/(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})/, '$1T$2Z');

  return new Date(isoString);
};

export default utcDateTimeToJsDate;
